import { createContext, useContext, useMemo, useState, type ReactNode } from 'react'
import { translations, type Language, type TranslationKey } from '../lib/i18n'

type LanguageContextValue = { language: Language; setLanguage: (language: Language) => void; t: (key: TranslationKey) => string }
const LanguageContext = createContext<LanguageContextValue | null>(null)

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [language, setLanguageState] = useState<Language>(() => localStorage.getItem('sg-flow-language') === 'ru' ? 'ru' : 'pl')
  const setLanguage = (next: Language) => {
    localStorage.setItem('sg-flow-language', next)
    document.documentElement.lang = next
    setLanguageState(next)
  }
  const value = useMemo(() => ({ language, setLanguage, t: (key: TranslationKey) => translations[language][key] }), [language])
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
}

export function useLanguage() {
  const context = useContext(LanguageContext)
  if (!context) throw new Error('useLanguage must be used inside LanguageProvider')
  return context
}
